import { render, staticRenderFns } from "./batchdetails.vue?vue&type=template&id=558d2505"
import script from "./batchdetails.vue?vue&type=script&lang=js"
export * from "./batchdetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports